// extracted by mini-css-extract-plugin
export default {"body":"History_body__Krh10","cellButton":"History_cellButton__eWzhA","subBody":"History_subBody__gMfv0"};